<template>
  <el-container>
    <el-header class="header-long-global">
      <img src="../assets/logo.svg" class="header-logo" />
      <el-select
        style="margin-left: 44px"
        v-model="lang"
        placeholder
        @change="changeLangEvent($event)"
      >
        <el-option v-for="item in language_list" :key="item.id" :label="item.type" :value="item.id"></el-option>
      </el-select>
      <div v-if="this.$route.path != '/sign-in'" class="user-info">
        <span class="info-text">
          <span class="info-text-row">{{ userInfo.nick_name }}</span>
          <span class="info-text-row">{{ userInfo.email }}</span>
        </span>

        <el-dropdown trigger="click" @command="handleCommand">
          <el-avatar shape="circle" icon="el-icon-user-solid" :src="heardUrl"></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="0">{{
              $t("commonInfo.UpdateInfo")
            }}</el-dropdown-item>-->
            <el-dropdown-item command="1">
              {{
              $t("commonInfo.ChangePassword")
              }}
            </el-dropdown-item>
            <el-dropdown-item command="2">
              {{
              $t("commonInfo.AboutSystem")
              }}
            </el-dropdown-item>
            <el-dropdown-item command="3">
              {{
              $t("commonInfo.LogOut")
              }}
            </el-dropdown-item>
            <el-dropdown-item command="4">
              {{
              $t("commonInfo.ClearCache")
              }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container>
      <el-aside style="min-width:200px" width="null">
        <el-menu
          class="header-main-menu"
          :default-active="
            $route.path ? $route.path.substr(1) : aside_list[0].children[0].path
          "
          background-color="#545c64"
          text-color="#fff"
          mode="vertical"
          active-text-color="#03aef9"
          router
          :collapse="isCollapse"
        >
          <template v-for="(item, index) in aside_list">
            <el-submenu :index="index + ''" :key="index" v-show="item.name" v-if="item.catalogue">
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <div
                v-for="child in item.children"
                :key="child.path"
                v-show="child.name && child.isShow"
              >
                <div v-if="child.children">
                  <el-submenu :index="child.path" v-show="child.name && child.isShow">
                    <template slot="title">{{ child.name }}</template>
                    <el-menu-item
                      v-for="v in child.children"
                      :index="v.path"
                      :key="v.path"
                      v-show="v.name && v.isShow"
                    >{{ v.name }}</el-menu-item>
                  </el-submenu>
                </div>
                <div v-else>
                  <span v-if="type != child.type">
                    <el-menu-item
                      :index="child.path"
                      v-show="child.name && child.isShow"
                    >{{ child.name }}</el-menu-item>
                  </span>
                </div>
              </div>
            </el-submenu>
            <el-menu-item :index="item.path" v-else :key="index">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-main class="header-main-frame">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import storage from "../../public/static/js/storage";
export default {
  name: "Home",
  data: function() {
    return {
      userInfo: {},
      aside_list: [],
      authRoute: {},
      enableRoute: [],
      isCollapse: false,
      heardUrl: "",
      language_list: [
        {
          id: "zh",
          type: "中文"
        },
        {
          id: "en",
          type: "English"
        }
      ],
      lang: "zh"
    };
  },
  created() {},
  methods: {
    changeLangEvent(value) {
      this.$confirm(
        this.$t("commonInfo.ChangeLanguage"),
        this.$t("commonInfo.Tips"),
        {
          confirmButtonText: this.$t("commonInfo.Confirm"),
          cancelButtonText: this.$t("commonInfo.Cancel"),
          type: "warning"
        }
      )
        .then(() => {
          this.clear_cache();
          this.$i18n.locale = value;
          this.$common.setGlobalStorage("language", value);
          location.reload();
        })
        .catch(err => {
          this.lang =
            storage.get(this.$common.getGlobalStorageKeyName("language")) ||
            "zh";
        });
    },
    getUserInfo: function() {
      this.userInfo = JSON.parse(sessionStorage.getItem("_user"));
    },
    handleCommand(command) {
      switch (command) {
        case "0":
          this.$router.push("/user-update-info");
          break;
        case "1":
          this.$router.push("/user-update-password");
          break;
        case "2":
          this.$router.push("/about-system");
          break;
        case "3":
          this.signOutOnclick();
          break;
        case "4":
          this.clear_cache();
          break;
      }
    },
    signOutOnclick() {
      let _me = this;
      this.$confirm(
        this.$t("commonInfo.logOutConfirm"),
        this.$t("commonInfo.Tips"),
        {
          confirmButtonText: this.$t("commonInfo.Confirm"),
          cancelButtonText: this.$t("commonInfo.Cancel"),
          type: "warning"
        }
      )
        .then(() => {
          _me.signOut();
        })
        .catch(() => {});
    },
    signOut: function() {
      sessionStorage.removeItem("_user");
      sessionStorage.removeItem("_token");
      sessionStorage.removeItem("_login");
      this.$router.push("/sign-in");
      setTimeout(function() {
        window.location.reload();
      }, 50);
    },
    // 清除本地缓存
    clear_cache() {
      window.sessionStorage.removeItem("address_info"); //包括国家，省份，城市
      window.sessionStorage.removeItem("country_list"); //国家列表
      window.sessionStorage.removeItem("province_list"); //省份列表
      window.sessionStorage.removeItem("city_list"); //城市列表
      window.sessionStorage.removeItem("score_stard_list"); //评分标准
      window.sessionStorage.removeItem("retail_area_type_list"); //零售区类型
      // window.location.reload();
    }
  },
  mounted() {
    let _me = this;
    if (this.$common.getGlobalStorage("language") != undefined) {
      _me.$i18n.locale = this.$common.getGlobalStorage("language");
      _me.lang = this.$common.getGlobalStorage("language");
    }

    // 获取用户信息
    this.getUserInfo();
    // 设置用户头像
    if (this.userInfo.avatar !== undefined && this.userInfo.avatar.length > 0) {
      // eslint-disable-next-line no-undef
      this.heardUrl = this.userInfo.avatar;
    }

    let currentPath = _me.$route.path;
    _me.authRoute = new Map();
    _me.enableRoute = new Map();
    // 获取用户信息
    let userInfo = JSON.parse(sessionStorage.getItem("_user"));
    if (!userInfo) {
      _me.$router.push({ path: "/sign-in" });
      return;
    }
    _me.type = userInfo.type;
    let authList = userInfo.api_auth_category_list;

    let route_list = this.$t("routeList");
    if (authList && authList.length > 0) {
      _me.userInfo = userInfo;
      authList.forEach(e => {
        _me.authRoute.set(e.identifier, 1);
      });
      // 根据登录返回的权限列表进行筛选对应权限的路由列表
      route_list.forEach(v => {
        if (_me.authRoute.get(v.title) === 1) {
          _me.aside_list.push(v);

          let child = v.children;
          //   一级目录下的路径
          if (child && child.length > 0) {
            child.forEach(item => {
              _me.enableRoute.set("/" + item.path, 1);
              //   二级目录下的路径
              if (item.children && item.children.length > 0) {
                item.children.forEach(e => {
                  _me.enableRoute.set("/" + e.path, 1);
                });
              }
            });
          }
        }
      });

      if (_me.enableRoute.get(currentPath) !== 1) {
        // 跳转到新侧边栏列表的第一个
        let path = "";
        if (_me.aside_list[0].children) {
          path = _me.aside_list[0].children[0].path;
        } else {
          path = _me.aside_list[0].path;
        }
        _me.$router.push({ path: "/" + path });
        return;
      }
    } else {
      _me.$router.push({ path: "/sign-in" });
      _me.$message({
        message: _me.$t("commonInfo.accountNoPermission"),
        type: "error"
      });
    }
  },
  created() {}
};
</script>

<style>
.user-info {
  flex: 1;
  display: flex;
  justify-content: end;
  float: right;
  color: #ffffff;
}

.info-text {
  float: left;
  padding-right: 10px;
}

.info-text-row {
  display: block;
  text-align: right;
  line-height: 20px;
}
</style>
